/**
 * Type of reference obligation for credit derivatives contracts.
 * tag: 1739
 * @readonly
 * @enum {string} (String)
 */
export enum ObligationType {
  /** Bond */
  Bond = '0',
  /** Convertible bond */
  ConvertBond = '1',
  /** Mortgage */
  Mortgage = '2',
  /** Loan */
  Loan = '3',
}
